import { useState, type ReactNode } from 'react';
import { Button } from './Button';

interface AISuggestionProps {
  title: string;
  children: ReactNode;
  onAccept: () => void;
  onReject: () => void;
  onEdit?: () => void;
  loading?: boolean;
  className?: string;
}

export function AISuggestion({
  title,
  children,
  onAccept,
  onReject,
  onEdit,
  loading = false,
  className = '',
}: AISuggestionProps) {
  return (
    <div className={`ai-suggestion ${className}`}>
      <div className="ai-suggestion__header">
        <span className="ai-suggestion__badge">AI</span>
        <span className="ai-suggestion__title">{title}</span>
      </div>
      <div className="ai-suggestion__body">{children}</div>
      <div className="ai-suggestion__actions">
        <Button variant="ghost" size="sm" onClick={onReject} disabled={loading}>
          Reject
        </Button>
        {onEdit && (
          <Button variant="secondary" size="sm" onClick={onEdit} disabled={loading}>
            Edit
          </Button>
        )}
        <Button variant="primary" size="sm" onClick={onAccept} loading={loading}>
          Accept
        </Button>
      </div>
    </div>
  );
}

interface AISuggestionDiffProps {
  original: string;
  refined: string;
  onAccept: () => void;
  onReject: () => void;
  loading?: boolean;
}

export function AISuggestionDiff({
  original,
  refined,
  onAccept,
  onReject,
  loading = false,
}: AISuggestionDiffProps) {
  const [showOriginal, setShowOriginal] = useState(false);

  return (
    <div className="ai-suggestion ai-suggestion--diff">
      <div className="ai-suggestion__header">
        <span className="ai-suggestion__badge">AI</span>
        <span className="ai-suggestion__title">AI Refinement</span>
        <button
          className="ai-suggestion__toggle"
          onClick={() => setShowOriginal(!showOriginal)}
        >
          {showOriginal ? 'Show Refined' : 'Show Original'}
        </button>
      </div>
      <div className="ai-suggestion__body">
        {showOriginal ? (
          <div className="ai-suggestion__text ai-suggestion__text--original">
            <p className="ai-suggestion__text-label">Original</p>
            <p>{original}</p>
          </div>
        ) : (
          <div className="ai-suggestion__text ai-suggestion__text--refined">
            <p className="ai-suggestion__text-label">Refined</p>
            <p>{refined}</p>
          </div>
        )}
      </div>
      <div className="ai-suggestion__actions">
        <Button variant="ghost" size="sm" onClick={onReject} disabled={loading}>
          Reject
        </Button>
        <Button variant="primary" size="sm" onClick={onAccept} loading={loading}>
          Accept
        </Button>
      </div>
    </div>
  );
}
